import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { motion } from "framer-motion";

const C = {
  dark: "#0C1F2F",
  navy: "#0057A8",
  navyDark: "#003D73",
  gold: "#FFCD00",
  teal: "#5BC8AF",
  gray: "#F5F7FA",
  white: "#ffffff",
};

const STATS = [
  { num: "10+", label: "Años de experiencia" },
  { num: "500+", label: "Clientes satisfechos" },
  { num: "5", label: "Marcas líderes" },
];

export default function QuienesSomos() {
  return (
    <Box
      id="quienes-somos"
      sx={{
        background: C.white,
        pt: { xs: "100px", md: "120px" },
        pb: 0,
        boxSizing: "border-box",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          maxWidth: "1140px",
          mx: "auto",
          px: { xs: "20px", sm: "32px", md: "40px" },
          boxSizing: "border-box",
          width: "100%",
        }}
      >
        {/* Título unificado en una sola línea y negro */}
        <Box
          component={motion.div}
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          sx={{ textAlign: "center", mb: { xs: 5, md: 8 } }}
        >
          <Typography
            variant="h2"
            sx={{
              color: C.dark,
              fontWeight: 900,
              fontSize: { xs: 32, sm: 42, md: 52 },
              lineHeight: 1.1,
              letterSpacing: "-.02em",
            }}
          >
            ¿Quiénes Somos?
          </Typography>
        </Box>

        {/* Contenido: Texto a la izquierda, Stats a la derecha */}
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            gap: { xs: "40px", md: "60px" },
            alignItems: "center",
          }}
        >
          <Box
            component={motion.div}
            initial={{ opacity: 0, x: -24 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.15 }}
            sx={{ flex: 1 }}
          >
            <Typography
              sx={{
                color: "#4a5a68",
                fontSize: { xs: 15, md: 16.5 },
                lineHeight: 1.85,
                mb: 2.5,
              }}
            >
              <Box component="span" sx={{ color: C.navy, fontWeight: 700 }}>
                En ELÉCTRICA GRM somos distribuidores de las mejores marcas de
                material eléctrico
              </Box>{" "}
              y les damos la bienvenida a nuestro sitio web, implementado para
              brindar un servicio más rápido y eficiente.
            </Typography>
            <Typography
              sx={{
                color: "#4a5a68",
                fontSize: { xs: 15, md: 16.5 },
                lineHeight: 1.85,
              }}
            >
              Ponemos a su disposición lo más avanzado en automatización,
              control, material eléctrico industrial y residencial. Además,
              contamos con personal técnico calificado para brindar soporte en
              sus instalaciones y en la construcción de tableros eléctricos.
            </Typography>
          </Box>

          <Box
            component={motion.div}
            initial={{ opacity: 0, x: 24 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.3 }}
            sx={{
              flex: 1,
              display: "flex",
              gap: "20px",
              flexWrap: "wrap",
              justifyContent: "center",
              width: "100%",
            }}
          >
            {STATS.map((s) => (
              <Box
                key={s.label}
                sx={{
                  background: C.gray,
                  borderRadius: "16px",
                  p: { xs: "20px", md: "24px" },
                  textAlign: "center",
                  flex: "1 1 140px",
                  boxShadow: "0 4px 14px rgba(0,0,0,0.03)",
                }}
              >
                <Typography
                  sx={{
                    color: C.navy,
                    fontWeight: 900,
                    fontSize: { xs: 28, md: 36 },
                    lineHeight: 1,
                  }}
                >
                  {s.num}
                </Typography>
                <Typography
                  sx={{
                    color: "#8a9aaa",
                    fontSize: { xs: 12, md: 13 },
                    fontWeight: 600,
                    mt: 1,
                  }}
                >
                  {s.label}
                </Typography>
              </Box>
            ))}
          </Box>
        </Box>
      </Box>

      {/* Unión directa con MisionVision (azul) */}
      <Box
        sx={{
          height: { xs: "120px", md: "180px" },
          background: `linear-gradient(180deg, ${C.white} 0%, ${C.navy} 100%)`,
          mt: { xs: 7, md: 10 },
        }}
      />
    </Box>
  );
}
